import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Alert, Badge, Button, Form, Modal } from 'react-bootstrap';
import { apiService } from '../services/apiService';
import { errorMessage } from '../services/quoteUtils';

export default function ProjectDirectory() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState(null);
  const [error, setError] = useState('');
  const [show, setShow] = useState(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [busy, setBusy] = useState(false);
  const [search, setSearch] = useState('');
  const load = useCallback(async () => {
    const result = await apiService.listWorkspaces();
    setProjects(result.projects); setError('');
  }, []);
  useEffect(() => { load().catch(failure => setError(errorMessage(failure))); }, [load]);
  const visible = projects?.filter(project => `${project.name} ${project.description}`.toLowerCase().includes(search.toLowerCase()));
  return <section className="mb-4" aria-label="Project groups">
    <div className="bomwise-page-heading">
      <div><div className="bomwise-eyebrow">PROJECT WORKSPACE</div><h1>Projects</h1>
        <p className="text-muted mb-0">Group related BOMs and compare supplier responses without losing source-line identity.</p></div>
      <Button onClick={() => setShow(true)}>New project</Button>
    </div>
    {error && <Alert variant="danger">{error} <Button variant="link" onClick={() => load().catch(failure => setError(errorMessage(failure)))}>Retry projects</Button></Alert>}
    <Form.Control className="mb-3" size="sm" style={{ maxWidth: 350 }} aria-label="Search project groups"
      placeholder="Find a project…" value={search} onChange={event => setSearch(event.target.value)} />
    {projects === null && !error && <p>Loading projects…</p>}
    {visible?.length === 0 && <div className="bomwise-project-empty">No projects here yet. Create one to group your BOMs; existing independent BOMs remain available below.</div>}
    <div className="bomwise-project-cards">{visible?.map(project => <Link className="bomwise-project-card"
      key={project.project_id} to={`/projects/${encodeURIComponent(project.project_id)}`}>
      <div className="d-flex justify-content-between gap-2"><h2>{project.name}</h2><Badge bg="secondary">{project.role}</Badge></div>
      <p>{project.description || 'Open project to view its BOMs and quotes.'}</p>
      <small>{project.is_owner ? 'Owned by you' : `Shared by ${project.owner_email}`}</small>
    </Link>)}</div>
    <Modal show={show} onHide={() => !busy && setShow(false)}>
      <Form onSubmit={async event => {
        event.preventDefault(); if (busy) return;
        setBusy(true); setError('');
        try {
          const result = await apiService.mutateWorkspace('create', { name: name.trim(), description: description.trim() });
          setShow(false); navigate(`/projects/${encodeURIComponent(result.project_id)}`);
        } catch (failure) { setError(errorMessage(failure)); }
        finally { setBusy(false); }
      }}>
        <Modal.Header closeButton><Modal.Title>New project</Modal.Title></Modal.Header>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form.Group className="mb-3" controlId="project-create-name"><Form.Label>Project name</Form.Label>
            <Form.Control required maxLength={160} disabled={busy} value={name} onChange={event => setName(event.target.value)} /></Form.Group>
          <Form.Group controlId="project-create-description"><Form.Label>Description (optional)</Form.Label>
            <Form.Control as="textarea" maxLength={2000} disabled={busy} value={description} onChange={event => setDescription(event.target.value)} /></Form.Group>
        </Modal.Body>
        <Modal.Footer><Button type="submit" disabled={busy || !name.trim()}>Create project</Button></Modal.Footer>
      </Form>
    </Modal>
  </section>;
}
